import React, { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import Label from "../../../../components/Label";
import Select from "../../../../components/ReactSelect";
import SearchInput, { Value } from "../../../../components/SearchInput";
import DateRangeModal from "../DateRangeModal";
import {
  resetFilter,
  selectDateRange,
  selectDateRanges,
  selectFilterDateRange,
  selectPrincipalState,
  updateFilter,
  updateTextFilter,
} from "../../../../store/principal";
import { selectTenantCode } from "../../../../store/metadata";
import { ButtonText } from "../../../../components/ButtonText/ButtonText";
import { ISelectedDate, Option } from "./types";
import { CUSTOME } from "./constant";

import "./styles.scss";

export const FilterSection: FC = () => {
  const [isDateRangeModalOpened, setIsDateRangeModalOpened] = useState(false);
  const dispatch = useDispatch();
  const tenantCode = useSelector(selectTenantCode);
  const data = useSelector(selectPrincipalState);
  const dates = useSelector(selectDateRanges);
  const dateRange = useSelector(selectFilterDateRange);
  const dateRangeObj = useSelector(selectDateRange);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(updateFilter({ tenantCode }));
  }, [tenantCode, dispatch]);

  const handleDateRangeChange = (selectedDate: ISelectedDate) => {
    const value = selectedDate.value;

    if (value === CUSTOME) {
      setIsDateRangeModalOpened(true);
      return;
    }
    dispatch(
      updateFilter({
        filterDateRange: {
          type: value,
        },
      }),
    );
  };

  const handleResetFilter = () => {
    dispatch(resetFilter());
  };

  const handleSearchChange = (value: Value) => {
    dispatch(updateTextFilter(value));
  };

  const handleSearchSubmit = (value: Value) => {
    dispatch(updateFilter({ filterText: value }));
  };

  const handleDateRangeDismiss = () => {
    setIsDateRangeModalOpened(false);
  };

  const handleDateRangeSubmit = ([startDate, endDate]: [string, string]) => {
    setIsDateRangeModalOpened(false);
    dispatch(
      updateFilter({
        filterDateRange: { type: "custom", startDate, endDate },
      }),
    );
  };

  const validateSearch = (value: string) => {
    return value.length >= 3;
  };

  const dateRangeOptionTitle = (): string => {
    if (!dateRangeObj.startDate && !dateRangeObj.endDate) {
      return "all";
    }

    return `${dateRangeObj.startDate} - ${dateRangeObj.endDate}`;
  };

  const selectedDateRange = dates.find((date: Option) => {
    return dateRange === date.value;
  });

  return (
    <section className="ams-filters">
      <div className="ams-filter-group ams-search-group">
        <Label className="ams-filters__label">{t("search")}</Label>
        <SearchInput
          value={data.filterText.value}
          onSearchChange={handleSearchChange}
          onSearchSubmit={handleSearchSubmit}
          validate={validateSearch}
        />
      </div>
      <div className="ams-filter-group ams-date-range-group">
        <Label className="ams-filters__label">{t("dateRange")}</Label>
        <Select
          className="ams-filters__select"
          name="filterDateRange"
          options={dates}
          onChange={handleDateRangeChange}
          value={selectedDateRange}
          title={dateRangeOptionTitle()}
        />
      </div>

      <ButtonText className="ams-filter-button" onClick={handleResetFilter}>
        {t("reset")}
      </ButtonText>
      {isDateRangeModalOpened ? (
        <DateRangeModal
          isOpen={isDateRangeModalOpened}
          onDismiss={handleDateRangeDismiss}
          onSubmit={handleDateRangeSubmit}
        />
      ) : null}
    </section>
  );
};
